<div
  class="notification-container"
  [ngClass]="toastClasses()"
>
  <div class="notification-content">
    <div class="notification-icon">
      <ui-svg-icon [svgIcon]="alertIcon()" size="large"></ui-svg-icon>
    </div>
    <div class="notification-text">
      <div *ngIf="multipleMessages" [style]="{
        marginLeft: '15px'
      }">
        <ul>
          <li *ngFor="let msg of getMessages()" class="notification-message" [innerHTML]="msg"></li>
        </ul>
      </div>
      <div *ngIf="data.variant === 'PROMPT_TO_ORDER_ERROR'" class="prompt_to_order_error">
        <h3 class="prompt_to_order_error_title">{{ data.variantTitle }}</h3>
        <span class="prompt_to_order_error_message">{{data.message}}</span>
      </div>
      <div *ngIf="isErpPushError()" class="erp_push_error">
        <h3 class="erp_push_error_title">{{ data.variantTitle }}</h3>
        <span class="erp_push_error_detail">{{ data.message }}</span>
      </div>
      <p *ngIf="!multipleMessages && data.variant !== 'PROMPT_TO_ORDER_ERROR' && !isErpPushError()" [innerHTML]="data.message"></p>
      <a *ngIf="link" class="notification-link" (click)="navigateToLink()">
        {{ 'common.toaster.view_link' | translate }}
      </a>
    </div>
  </div>
  <button *ngIf="data.actionLabel" class="notification-action" type="button" (click)="onActionClick()">
    {{ data.actionLabel }}
  </button>
  <div class="close-button" (click)="closeToast()">
    <ui-svg-icon svgIcon="close-cc" size="medium"></ui-svg-icon>
  </div>
</div>
